import { useState } from "react";
import { motion } from "motion/react";
import COLORS from "../config/colors";

const Checkbox = ({
  checked = false,
  fillColor = COLORS.bjelin_light_grey,
  useInternalSate = false,
  style = {}
}) => {
  const [isChecked, setIsChecked] = useState(checked);

  const animations = {
    empty: {
      pathLength: 0,
      opacity: 0,
      transition: {
        type: "spring",
        damping: 20,
        stiffness: 200,
        mass: 1
      }
    },
    checked: {
      pathLength: 1,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 22,
        stiffness: 200,
        mass: 1
      }
    }
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      style={{ width: "28px", height: "28px", marginRight: "7px", ...style }}
      onClick={() => {
        if (useInternalSate) setIsChecked(!isChecked);
      }}
    >
      <rect height="50" width="50" fill={fillColor} />
      <motion.path
        fill="none"
        strokeWidth="5"
        stroke="#000"
        d="M14,26 L 22,33 L 35,16"
        strokeDasharray="0 1"
        initial="empty"
        animate={
          (useInternalSate && isChecked) || (!useInternalSate && checked)
            ? "checked"
            : "empty"
        }
        variants={animations}
      />
    </svg>
  );
};

export default Checkbox;
